import React, { useState, useEffect, useRef } from 'react'
import './GroupsCharts.css'
//components
import DashboardFilter from '../fragments/DashboardFilter'
import Donut from '../../../components/Charts/Donut/Donut'
import SubcategoriesTable from '../../../components/SubcategoriesTable/SubcategoriesTable'
import Ranking from '../../../components/Ranking/Ranking'
//services
import { dashboardService } from '../../../services/Dashboard';
//utils
import { formatShortDate, getMonth } from '../../../utils/utils';

const GroupsCharts = () => {
  const chartRef = useRef(null);
  const customColors = ['#15B79E', '#0E5F79', '#F2994A'];
  const [statusGroup, setStatusGroup] = useState([])
  const [totalGroups, setTotalGroups] = useState(0)
  const [topGroups, setTopGroups] = useState([])
  const [groupActivity, setGroupActivity] = useState([])

  useEffect(() => {
    fetchStatusGroup();
    fetchTopGroups();
    fetchGroupActivity();
  }, []);

  const fetchStatusGroup = async (filters = {}) => {
    try {
      const start_date = filters.rangeDate ? formatShortDate(filters.rangeDate.start_date, '-') : null;
      const end_date = filters.rangeDate ? formatShortDate(filters.rangeDate.end_date, '-') : null;
      const group_by = filters.period ? filters.period.value : null;
      const params = {
        ...(start_date && { start_date }),
        ...(end_date && { end_date }),
        ...(group_by && { group_by })
      };
      const response = await dashboardService.groupsDistribution(params);
      if(response && response.series && response.series.length > 0){
        const data = response.series.map(item => ({
          x: item.label,
          y: item.value
        }));
        setStatusGroup(data);
        setTotalGroups(response.total);
      }else{
        setStatusGroup([]);
        setTotalGroups(0);
      }
    } catch (error) {
      console.error('Error fetching status group:', error);
    }
  };

  const fetchTopGroups = async (filters = {}) => {
    try {
      const start_date = filters.rangeDate ? formatShortDate(filters.rangeDate.start_date, '-') : null;
      const end_date = filters.rangeDate ? formatShortDate(filters.rangeDate.end_date, '-') : null;
      const group_by = filters.period ? filters.period.value : null;
      const params = {
        ...(start_date && { start_date }),
        ...(end_date && { end_date }),
        ...(group_by && { group_by })
      };
      const response = await dashboardService.topGroups(params);
      if(response && response.data && response.data.length > 0){
        setTopGroups(response.data);
      }else{
        setTopGroups([]);
      }
    } catch (error) {
      console.error('Error fetching top groups:', error);
    }
  };

  const fetchGroupActivity = async (filters = {}) => {
    try {
      const start_date = filters.rangeDate ? formatShortDate(filters.rangeDate.start_date, '-') : null;
      const end_date = filters.rangeDate ? formatShortDate(filters.rangeDate.end_date, '-') : null;
      const group_by = filters.period ? filters.period.value : null;
      const params = {
        limit: 10,
        offset: 0,
        ...(start_date && { start_date }),
        ...(end_date && { end_date }),
        ...(group_by && { group_by })
      };
      const response = await dashboardService.groupActivity(params);
      if(response && response.data && response.data.length > 0){
        setGroupActivity(response.data);
      }else{
        setGroupActivity([]);
      }
    } catch (error) {
      console.error('Error fetching group activity:', error);
    }
  };

  return (
    <div className="packages-charts-container">
    <DashboardFilter 
      chartRef={chartRef}
      onApplyFilters={(filters) => {
        fetchStatusGroup(filters);
        fetchTopGroups(filters);
        fetchGroupActivity(filters);
      }}
    />
    <div className="chart-wrapper" ref={chartRef}>
      <Donut 
        data={statusGroup}
        isTotal={true}
        total={totalGroups}
        title="Status of groups"
        height={170}
        width={400}
        innerRadius={40}
        outerRadius={80}
        colors={customColors}
      />
      <Ranking 
        data={topGroups}
        title="Top groups"
        height={'225px'}
        width={'50%'}
        innerRadius={40}
        outerRadius={80}
        colors={customColors}
      />
    </div>
    <SubcategoriesTable 
      title="Group activity"
      data={groupActivity}
      columns={[
        { header: 'Group name', field: 'group_name' },
        { header: 'Members', field: 'members' },
        { header: 'Services completed', field: 'services_completed' },
        { header: 'Barter bucks', field: 'barter_bucks' },
        { header: 'Last activity', field: 'last_activity' }
      ]}
    />
  </div>
  )
}

export default GroupsCharts
